import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import {
   Button,
   Icon,
   Input,
   Form,
   Message,
   Modal,
} from 'semantic-ui-react';

const closeModalIconStyle = {
  float: 'right',
  cursor: 'pointer',
};

const noPadding = {
  padding: 0,
};

const labelStyle = {
  fontSize: '16px',
};

const AddTeamMemberForm = props => {
  const {
    errors,
    user,
    addingUser,
    formChangeHandler,
    addUserHandler,
    popupToggleHandler,
  } = props;
  const { name, email } = user;
  return (
    <Modal
      open size="tiny"
      onClose={popupToggleHandler}
      closeOnEscape
    >
      <Modal.Header className="align-center">
            Add a new team member
            <Icon
              name="delete"
              style={closeModalIconStyle}
              onClick={popupToggleHandler}
            />
      </Modal.Header>
      <Modal.Content>
        { errors && (errors.name || errors.email) &&
        <Message
          error
          header="There were some errors with your submission"
          list={_.values(errors)}
        />
            }
        <Form onSubmit={addUserHandler} onChange={formChangeHandler}>
          <Form.Group inline>
            <Form.Field width={4}>
              <label htmlFor="name" style={labelStyle}>
                    Name
                  </label>
            </Form.Field>
            <Form.Field error={errors.name} inline width={12} style={noPadding}>
              <Input id="name"name="name" value={name} style={noPadding} onChange={formChangeHandler} />
            </Form.Field>
          </Form.Group>
          <Form.Group inline>
            <Form.Field width={4}>
              <label htmlFor="email" style={labelStyle}>
                    Email
                  </label>
            </Form.Field>
            <Form.Field error={errors.email} inline width={12} style={noPadding}>
              <Input id="email" name="email" value={email} onChange={formChangeHandler} />
            </Form.Field>
          </Form.Group>
          <Form.Group>
            <Form.Field width={16}>
              <Button
                loading={addingUser}
                disabled={addingUser}
                fluid
                color="pink"
              ><Icon name="plus" /> Add team member</Button>
            </Form.Field>
          </Form.Group>
        </Form>
      </Modal.Content>
    </Modal>
  );
};

AddTeamMemberForm.propTypes = {
  errors: PropTypes.array.isRequired,
  user: PropTypes.object.isRequired,
  addingUser: PropTypes.bool.isRequired,
  addUserHandler: PropTypes.func.isRequired,
  formChangeHandler: PropTypes.func.isRequired,
  popupToggleHandler: PropTypes.func.isRequired,
};

export default AddTeamMemberForm;



/** WEBPACK FOOTER **
 ** ./src/components/add-team-member-form/index.js
 **/